import { getMondayOfWeek, getWeekNumber, modifyTime } from '../utils'
import moment from 'moment'

export function modifyStartTime(date) {
  return modifyTime(date, 0, 0, 0)
}

export function modifyEndTime(date) {
  return modifyTime(date, 23, 59, 59)
}

function getPreviousWeekMonday(date) {
  let d = new Date(date)
  d.setDate(d.getDate() - 7) // Move back by 7 days
  return getMondayOfWeek(getWeekNumber(d), d)
}

function getNextWeekMonday(date) {
  let d = new Date(date)
  d.setDate(d.getDate() + 7) // Move forward by 7 days
  return getMondayOfWeek(getWeekNumber(d), d)
}

/**
 *
 *
 * @param {number} [num=1]
 * @return {*}
 */
export function getYesterdayTime(num = 1) {
  const date = new Date()
  date.setTime(date.getTime() - 3600 * 1000 * 24 * num)
  return date
}

/**
 *
 * @description 根据需要传入不同的 monthOffset 值来获取任意月份的开始时间戳和结束时间戳。 -1：下个月 ，0: 当前月， 1: 获取上个月， 2：上两个月，
 * @param {number} [monthOffset=0]
 * @return {*}
 */
export function getMonthStartEndTimestamps(monthOffset = 0) {
  // 获取当前日期
  const currentDate = new Date()

  // 目标月份的年份和月份
  let targetYear = currentDate.getFullYear()
  let targetMonth = currentDate.getMonth() - monthOffset

  // 调整年份和月份，处理跨年情况
  while (targetMonth < 0) {
    targetYear--
    targetMonth += 12
  }

  // 目标月份的第一天的时间戳
  const firstDayOfTargetMonth = new Date(targetYear, targetMonth, 1)
  // const firstDayTimestamp = firstDayOfTargetMonth.getTime()

  // 目标月份的最后一天的时间戳
  const lastDayOfTargetMonth = new Date(targetYear, targetMonth + 1, 0)
  // const lastDayTimestamp = lastDayOfTargetMonth.getTime()

  // 返回一个包含开始和结束时间戳的对象
  return [firstDayOfTargetMonth, lastDayOfTargetMonth]
  // return [firstDayTimestamp, lastDayTimestamp]
}

// 这里的值是原始的时间戳
export const DEFAULT_SHORTCUTS_MAP = {
  date: [
    {
      text: '清除',
      // value: null,
      // style: { // 可配置
      //   color: '#7653D6'
      // },
      onClick: (picker) => {
        // picker.$emit('pick', null, false)
        picker.handleClear()
      },
    },
    {
      text: '今天',
      value: () => modifyStartTime(new Date()),
    },
    {
      text: '昨天',
      value: () => modifyStartTime(getYesterdayTime()),
    },
    {
      text: '前天',
      value: () => modifyStartTime(getYesterdayTime(2)),
    },
    {
      text: '3天前',
      value: () => modifyStartTime(getYesterdayTime(3)),
    },
    {
      text: '15天前',
      value: () => modifyStartTime(getYesterdayTime(15)),
    },
    {
      text: '30天前',
      value: () => modifyStartTime(getYesterdayTime(30)),
    },
    {
      text: '一周前',
      value: () => modifyStartTime(getYesterdayTime(7)),
    },
    {
      text: '选择月',
    },
  ],
  dates: [
    {
      text: '清除',
      onClick: (picker) => {
        picker.handleClear()
      },
    },
    {
      text: '最近三天',
      value: () => Array.from({length: 3}).map((_, i) => modifyStartTime(moment(moment().clone().subtract(i, 'days').format('YYYY-MM-DD')).toDate())).reverse(),
    },
    {
      text: '最近五天',
      value: () => Array.from({length: 5}).map((_, i) => modifyStartTime(moment(moment().clone().subtract(i, 'days').format('YYYY-MM-DD')).toDate())).reverse(),
    },
    {
      text: '最近一周',
      value: () => Array.from({length: 7}).map((_, i) => modifyStartTime(moment(moment().clone().subtract(i, 'days').format('YYYY-MM-DD')).toDate())).reverse(),
    },
  ],
  daterange: [
    {
      text: '清除',
      onClick: (picker) => {
        // picker.$emit('pick', null, false)
        // picker.handleClear()
        if (picker.singleValue) {
          const data = picker.value
          const activeInputIndex = picker.activeInputIndex
          const value = activeInputIndex === 0 ? ['', data[1] || ''] : [data[0] || '', '']
          picker.$emit('pick', value, false, false)
        } else {
          // picker.$emit('pick', null, false)
          picker.handleClear()
        }
      },
    },
    {
      text: '当月', // 这个月的第一天 - 个月的今天
      value: () => [modifyStartTime(moment().startOf('month').toDate()), modifyEndTime(moment().toDate())],
    },
    {
      text: '上月',
      value: () => [modifyStartTime(moment().subtract(1, 'months').startOf('month').toDate()), modifyEndTime(moment().subtract(1, 'months').endOf('month').toDate())],
    },
    {
      text: '下月',
      value: () => [modifyStartTime(moment().add(1, 'months').startOf('month').toDate()), modifyEndTime(moment().add(1, 'months').endOf('month').toDate())],
    },
    {
      text: '今天',
      value: () => [modifyStartTime(new Date()), modifyEndTime(new Date())],
    },
    {
      text: '昨天',
      value: () => [modifyStartTime(getYesterdayTime()), modifyEndTime(getYesterdayTime())],
    },
    {
      text: '最近一周',
      value: () => [modifyStartTime(getYesterdayTime(7)), modifyEndTime(new Date())],
    },
    {
      text: '最近一个月',
      value: () => [modifyStartTime(getYesterdayTime(30)), modifyEndTime(new Date())],
    },
    {
      text: '最近三个月',
      value: () => [modifyStartTime(getYesterdayTime(90)), modifyEndTime(new Date())],
    },
    {
      text: '最近六个月',
      value: () => [modifyStartTime(getYesterdayTime(180)), modifyEndTime(new Date())],
    },
    {
      text: '今年至今',
      value: () => [modifyStartTime(new Date(new Date().getFullYear(), 0)), modifyEndTime(new Date())],
    },
    {
      text: '选择月',
    },
  ],
  datetime: [
    {
      text: '清除',
      // value: () => null,
      // style: { // 可配置
      //   color: '#7653D6'
      // },
      onClick: (picker) => {
        // picker.$emit('pick', null, false)
        picker.handleClear()
      },
    },
    {
      text: '今天',
      value: () => modifyStartTime(new Date()),
    },
    {
      text: '昨天',
      value: () => modifyStartTime(getYesterdayTime()),
    },
    {
      text: '前天',
      value: () => modifyStartTime(getYesterdayTime(2)),
    },
    {
      text: '3天前',
      value: () => modifyStartTime(getYesterdayTime(3)),
    },
    {
      text: '15天前',
      value: () => modifyStartTime(getYesterdayTime(15)),
    },
    {
      text: '30天前',
      value: () => modifyStartTime(getYesterdayTime(30)),
    },
    {
      text: '一周前',
      value: () => modifyStartTime(getYesterdayTime(7)),
    },
    {
      text: '选择月',
    },
  ],
  datetimerange: [
    {
      text: '清除',
      onClick: (picker) => {
        if (picker.singleValue) {
          const data = picker.value
          const activeInputIndex = picker.activeInputIndex
          const value = activeInputIndex === 0 ? ['', data[1] || ''] : [data[0] || '', '']
          picker.$emit('pick', value, false, false)
        } else {
          // picker.$emit('pick', null, false)
          picker.handleClear()
        }
      },
    },
    {
      text: '当月', // 这个月的第一天 - 个月的今天
      value: () => [modifyStartTime(moment().startOf('month').toDate()), modifyEndTime(moment().toDate())],
    },
    {
      text: '上月',
      value: () => [modifyStartTime(moment().subtract(1, 'months').startOf('month').toDate()), modifyEndTime(moment().subtract(1, 'months').endOf('month').toDate())],
    },
    {
      text: '下月',
      value: () => [modifyStartTime(moment().add(1, 'months').startOf('month').toDate()), modifyEndTime(moment().add(1, 'months').endOf('month').toDate())],
    },
    {
      text: '今天',
      value: () => [modifyStartTime(new Date()), modifyEndTime(new Date())],
    },
    {
      text: '昨天',
      value: () => [modifyStartTime(getYesterdayTime()), modifyEndTime(getYesterdayTime())],
    },
    {
      text: '最近一周',
      value: () => [modifyStartTime(getYesterdayTime(7)), modifyEndTime(new Date())],
    },
    {
      text: '最近一个月',
      value: () => [modifyStartTime(getYesterdayTime(30)), modifyEndTime(new Date())],
    },
    {
      text: '最近三个月',
      value: () => [modifyStartTime(getYesterdayTime(90)), modifyEndTime(new Date())],
    },
    {
      text: '最近六个月',
      value: () => [modifyStartTime(getYesterdayTime(180)), modifyEndTime(new Date())],
    },
    {
      text: '今年至今',
      value: () => [modifyStartTime(new Date(new Date().getFullYear(), 0)), modifyEndTime(new Date())],
    },
    {
      text: '选择月',
    },
  ],
  month: [
    {
      text: '清除',
      onClick: (picker) => {
        picker.handleClear()
      },
    },
    {
      text: '当月',
      value: () => getMonthStartEndTimestamps()[0],
    },
    {
      text: '上月',
      value: () => getMonthStartEndTimestamps(1)[0],
    },
    {
      text: '下月',
      value: () => getMonthStartEndTimestamps(-1)[0],
    },
    // {
    //   text: '选择月',
    // },
  ],
  months: [
    {
      text: '清除',
      onClick: (picker) => {
        picker.handleClear()
      },
    },
    {
      text: '上月',
      value: () => [moment().subtract(1, 'months').startOf('month').toDate()],
    },
    {
      text: '近两个月',
      value: () => [1, 2].map(num => moment().subtract(num, 'months').startOf('month').toDate()),
    },
    {
      text: '近三个月',
      value: () => [1, 2, 3].map(num => moment().subtract(num, 'months').startOf('month').toDate())
    },
    {
      text: '近六个月',
      value: () => [1, 2, 3, 4, 5, 6].map(num => moment().subtract(num, 'months').startOf('month').toDate())
    },
  ],
  monthrange: [
    {
      text: '清除',
      onClick: (picker) => {
        // picker.$emit('pick', null, false)
        picker.handleClear()
      },
    },
    {
      text: '上月',
      value: () => [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()],
    },
    {
      text: '本月',
      value: () => [modifyStartTime(new Date()), modifyEndTime(new Date())],
    },
    {
      text: '最近三个月',
      value: () => [modifyStartTime(getYesterdayTime(90)), modifyEndTime(new Date())],
    },
    {
      text: '最近六个月',
      value: () => [modifyStartTime(getYesterdayTime(180)), modifyEndTime(new Date())],
    },
    {
      text: '今年至今',
      value: () => [modifyStartTime(new Date(new Date().getFullYear(), 0)), modifyEndTime(new Date())],
    },
  ],
  week: [
    {
      text: '清除',
      onClick: (picker) => {
        // picker.$emit('pick', null, false)
        picker.handleClear()
      },
    },
    {
      text: '上周',
      onClick: (picker) => {
        const date = getPreviousWeekMonday(picker.value || new Date())
        picker.$emit('pick', date, false)
      },
    },
    {
      text: '下周',
      onClick: (picker) => {
        const date = getNextWeekMonday(picker.value || new Date())
        picker.$emit('pick', date, false)
      },
    },
    // {
    //   text: '选择月',
    // },
  ],
}

export function createDiffernetShortcutsOnDateType(type) {
  try {
    return DEFAULT_SHORTCUTS_MAP[type] || []
  } catch (error) {
    return []
  }
}

export const MONTH_LIST = [
  '一月',
  '二月',
  '三月',
  '四月',
  '五月',
  '六月',
  '七月',
  '八月',
  '九月',
  '十月',
  '十一月',
  '十二月',
]



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/utils/shortcuts.js